import {
  Box,
  Grid,
  Button,
  Avatar,
  Typography
} from '@mui/material';

// Reemplaza InfoBox para "Contado real" con este:
const InfoBoxButton = ({ icon, label, value, gradient, onClick, disabled }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Box
      sx={{
        p: 2,
        borderRadius: 3,
        background: gradient,
        color: 'white',
        boxShadow: 2,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box display="flex" alignItems="center">
        <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', mr: 2 }}>
          {icon}
        </Avatar>
        <Box>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {label}
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {value}
          </Typography>
        </Box>
      </Box>
      <Button
        variant="outlined"
        size="small"
        onClick={onClick}
        sx={{ color: 'white', borderColor: 'white', ml: 2 }}
        disabled={disabled}
      >
        Editar
      </Button>
    </Box>
  </Grid>
);

export default InfoBoxButton;
